import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c56f380"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute overflow-hidden inset-0" }

import { computed } from 'vue'
import { getRelatedColors } from '../utils/colorUtils'


export default /*#__PURE__*/_defineComponent({
  props: {
  parentColor: {
    type: String,
    default: 'primary',
  },
  slideEffectColor: {
    type: String,
    default: undefined,
  },
  slideRight: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const slideOffsetClasses = computed(() => {
  if (props.slideRight) {
    return '-left-full group-hover:left-0 group-focus:left-0'
  }

  return '-right-full group-hover:right-0 group-focus:right-0'
})

const transitionBg = computed(() => {
  // Override calculated color effect
  if (props.slideEffectColor) {
    return 'bg-' + props.slideEffectColor
  }

  const color = props.parentColor
  const relatedColors = getRelatedColors(color)

  return relatedColors ? 'bg-' + relatedColors.effectColor : `bg-${color} opacity-60`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white slide-box", _unref(slideOffsetClasses)])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["slide-box", [_unref(transitionBg), _unref(slideOffsetClasses)]])
    }, null, 2)
  ]))
}
}

})